export const removeAuthToken = () => localStorage.removeItem('auth_token');
